export default __webpack_public_path__ + "static/media/shipping.13ca7cf7.png";